<template>
    <div>
        <div style="height: 40px;line-height: 40px;display: flex;">
            <div style="width: 50%;">
                <div class="crumbs mcrumb-self">
                    <el-breadcrumb separator="-">
                        <el-breadcrumb-item>
                            <i class="el-icon-user"></i><span>系统设置</span>
                        </el-breadcrumb-item>
                        <el-breadcrumb-item><span>角色管理</span></el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>
            <div style="width: 50%;">
                <div style="float: right;line-height: 32px;">
                    <span style="color: #606266;padding-right: 15px;">当前集团</span>
                    <el-select v-model="currGroupId" @change="currGroupSelectChange" placeholder="请选择" style="width: 365px;">
                        <el-option
                            v-for="item in groupComboData"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
        </div>
        <!-- <el-divider></el-divider> -->
        <div class="container" style="padding: 15px;">
            <div style="display: flex;">
                <div style="width: 30%;padding-right: 15px;">
                    <div style="display: flex;padding-left: 6px;height: 30px;line-height: 35px;">
                        <div style="width: 30%;">
                            <el-link type="primary" :underline="false" @click="addGroupClickFun()"><i class="el-icon-user"></i> 新增分组</el-link>
                        </div>
                        <div style="width: 70%;">
                            <el-link type="primary" :underline="false" @click="addRoleClickFun()"><i class="el-icon-user"></i> 新增角色</el-link>
                        </div>
                    </div>
                    <div style="padding-top: 10px;height: 92%;overflow-y: auto;">
                        <el-tree :data="roleTreeData" :props="defaultProps" @node-click="roleTreeNodeClick" node-key="id" :default-expanded-keys="defaultExpandRoleNode">
                            <span class="custom-tree-node" slot-scope="{ node, data }" @mouseenter="roleTreeNodeMouseEnter(data)" @mouseleave="roleTreeNodeMouseLeave(data)">
                                <span>{{ node.label }}</span>
                                <span style="height: 19px;line-height: 19px;padding-left: 20px;">
                                    <el-link v-show="data.del" type="primary" size="mini" @click="() => deleteRoleTreeNode(node, data)" icon="el-icon-delete"></el-link>
                                </span>
                            </span>
                        </el-tree>
                    </div>
                </div>
                <div style="width: 70%;padding-left: 15px;">
                    <div style="display: flex;height: 35px;line-height: 40px;">
                        <span v-if="show == true">{{ roleIdVal}}</span>
                        <span style="font-size: 20px;">{{ roleNameVal }}</span>
                        <span style="font-size: 14px;color: #909399;padding-left: 10px;">{{ roleNameDescVal }}</span>
                    </div>
                    <div style="padding-top: 10px;">
                        <el-tabs v-model="roleManageTabs"  style="height: 100%;">
                            <el-tab-pane label="角色成员" name="roleMember">
                                <div style="color: #DCDCDC;padding-bottom: 10px;">全部成员，共 {{ roleMemberCount }} 人</div>
                                <el-row type="flex" style="padding-bottom: 10px;">
                                    <el-col :span="8">
                                        <el-input v-model="roleManageSearchName" @keyup.native="advanceQueryRoleMemberData" placeholder="搜索姓名、用户名、手机号、邮箱" prefix-icon="el-icon-search" clearable></el-input>
                                    </el-col>
                                    <el-col :span="16" style="text-align: right;">
                                        <el-button plain @click="deleteRoleMemberClickFun()">批量移除</el-button>
                                        <el-button plain @click="addRoleMemberClickFun()">添加成员</el-button>
                                    </el-col>
                                </el-row>
                                <div>
                                    <el-table :data="roleMemberTableData" border height="520px" class="table" ref="roleMemberTable" @row-click="clickRowByChecked">
                                        <el-table-column type="selection" width="55" align="center"></el-table-column>
                                        <el-table-column prop="id" v-if='show'></el-table-column>
                                        <el-table-column prop="userName" label="姓名" sortable></el-table-column>
                                        <el-table-column prop="userCode" label="用户名" sortable></el-table-column>
                                        <el-table-column prop="phone" label="手机号" sortable></el-table-column>
                                        <el-table-column prop="email" label="邮箱" sortable></el-table-column>
                                    </el-table>
                                    <div class="pagination" style="text-align: center;">
                                        <el-pagination
                                            @size-change="handleSizeChange"
                                            @current-change="handleCurrentChange"
                                            :current-page="pwm.page"
                                            :page-size="pwm.limit"
                                            :page-sizes="pwm.limits"
                                            layout="total, sizes, prev, pager, next, jumper"
                                            :total="pwm.count">
                                        </el-pagination>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="功能权限" name="functionAuth">
                                <div style="color: #DCDCDC;padding-bottom: 10px;">设置角色对应的功能操作、应用管理、后台管理权限</div>
                                <div style="display: flex;height: 610px;">
                                    <div style="width: 40%;border: 1px solid #DCDFE6;border-right: none;padding: 15px 0px 0px 10px;">
                                        <div style="height: 550px;overflow-y: auto;">
                                            <el-tree :data="functionAuthTreeData" ref="functionAuthTree" :props="defaultProps" @node-click="funAuthNodeClick" show-checkbox node-key="id" :default-expand-all="defaultExpandAll" :default-checked-keys="defaultCheckedMenu" :disabled="dataRangeDisabled">

                                            </el-tree>
                                        </div>
                                        <el-row style="text-align: right;padding: 5px 10px;">
                                            <el-button type="primary" style="width: 80px;" @click="saveRoleAuthBtn()" v-if="showFunAuthBtn">保存</el-button>
                                        </el-row>
                                    </div>
                                    <div style="width: 60%;border: 1px solid #DCDFE6;">
                                        <div style="padding: 15px 0px 0px 34px;">
                                            <span v-if="show == true">{{ menuId }}</span>
                                            <el-row>{{ menuName }}</el-row>
                                            <div v-if="showMenuBtn" >
                                                <el-checkbox-group v-model="checkBtnList">
                                                    <div v-for="(childbtn, index) in childBtnList" :key="index">
                                                        <el-row  style="padding: 10px 0px 0px 15px;">
                                                                <el-checkbox :label="childbtn.id" @change="menuBtnChangeFun">{{ childbtn.label }}</el-checkbox>
                                                        </el-row>
                                                    </div>
                                                </el-checkbox-group>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="数据范围" name="dataRange">
                                <el-form :model="roleDataRangeForm" ref="roleDataRangeForm">
                                    <div style="height: 640px;padding-top: 5px;">
                                        <el-row type="flex" style="line-height: 35px;">
                                            <el-input v-if="show == true" v-model="roleDataRangeForm.dataRangeId"></el-input>
                                            <span style="padding-right: 15px;line-height: 35px;">密级权限</span>
                                            <el-radio-group v-model="roleDataRangeForm.levelAuthList" style="line-height: 35px;" :disabled="dataRangeDisabled">
                                                <el-radio label="1" style="line-height: 35px;width: 80px;">1级 - 绝密</el-radio>
                                                <el-radio label="2" style="line-height: 35px;width: 80px;">2级 - 机密</el-radio>
                                                <el-radio label="3" style="line-height: 35px;width: 80px;">3级 - 秘密</el-radio>
                                                <el-radio label="4" style="line-height: 35px;width: 80px;">4级 - 一般</el-radio>
                                                <el-radio label="5" style="line-height: 35px;width: 80px;">5级 - 公开</el-radio>
                                            </el-radio-group>
                                        </el-row>
                                        <el-row type="flex" style="line-height: 35px;">
                                            <span style="padding-right: 15px;">档案类别</span>
                                            <el-checkbox-group v-model="roleDataRangeForm.archivesTypeList" :disabled="dataRangeDisabled">
                                                <el-checkbox label="1" style="width: 80px;">会计凭证</el-checkbox>
                                                <el-checkbox label="2" style="width: 80px;">会计账簿</el-checkbox>
                                                <el-checkbox label="3" style="width: 80px;">会计报告</el-checkbox>
                                                <el-checkbox label="4" style="width: 80px;">其他会计资料</el-checkbox>
                                            </el-checkbox-group>
                                        </el-row>
                                        <el-row style="padding-top: 15px;padding-left: 20%;">
                                            <el-button type="primary" style="width: 80px;" @click="saveRoleAuthBtn()" v-if="showFunAuthBtn">保存</el-button>
                                        </el-row>
                                    </div>
                                </el-form>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                </div>
            </div>
        </div>

        <!-- 新建分组 -->
        <el-dialog title="新建分组" :visible.sync="addGroupDialogVisible" width="30%" :close-on-click-modal="false">
            <div class="custom-dialog">
                <el-form :model="addGroupForm" ref="addGroupForm" :rules="addGroupFormRule" style="width: 90%;margin: 0px auto;">
                    <el-row type="flex" style="line-height: 32px;padding-top: 15px;">
                        <el-col :span="6" style="text-align: right;padding-right: 15px;">分组名称</el-col>
                        <el-col :span="18">
                            <el-form-item prop="groupName">
                                <el-input v-model="addGroupForm.groupName"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveGroupDataClickFun('addGroupForm')" style="width: 80px;">保存</el-button>
                <el-button @click="addGroupDialogVisible = false" style="width: 80px;">返回</el-button>
            </span>
        </el-dialog>

        <!-- 新建角色 -->
        <el-dialog title="新增角色" :visible.sync="addRoleDialogVisible" width="30%" class="dialog" :close-on-click-modal="false">
            <div class="custom-dialog">
                <el-form :model="addRoleForm" ref="addRoleForm" :rules="addRoleFormRule" style="width: 90%;margin: 0px auto;">
                    <el-row type="flex" style="line-height: 35px;padding-top: 15px;">
                        <el-col :span="5" style="text-align: right;padding-right: 15px;"><span style="color: red;">*</span> 角色名</el-col>
                        <el-col :span="19">
                            <el-form-item prop="roleName">
                                <el-input v-model="addRoleForm.roleName"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row type="flex" style="line-height: 35px;padding-top: 10px;">
                        <el-col :span="5" style="text-align: right;padding-right: 15px;"><span style="color: red;">*</span> 角色组</el-col>
                        <el-col :span="19">
                            <el-form-item prop="roleGroupId">
                                <el-select v-model="addRoleForm.roleGroupId" placeholder="请选择" style="width: 100%;">
                                    <el-option
                                        v-for="item in roleGroupComboData"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row type="flex" style="line-height: 35px;padding-top: 12px;">
                        <el-col :span="5" style="text-align: right;padding-right: 15px;">描述</el-col>
                        <el-col :span="19">
                            <el-form-item prop="description">
                                <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="addRoleForm.description"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveRoleDataClickFun('addRoleForm')" style="width: 80px;">保存</el-button>
                <el-button @click="addRoleDialogVisible = false" style="width: 80px;">返回</el-button>
            </span>
        </el-dialog>
        
        <!-- 添加成员 -->
        <el-dialog title="选择成员" :visible.sync="addRoleMemberDialogVisible" width="45%" class="custom-add-member-dialog">
            <div class="custom-dialog">
                <el-transfer :titles="['未选择成员', '已选择成员']" filterable filter-placeholder="关键词搜索" v-model="roleMemberChecked" :data="roleMemberData">
                    <!-- :right-default-checked="roleMemberChecked" -->
                    <!-- <span slot-scope="{ option }">{{ option.key }} - {{ option.label }}</span> -->
                    <span slot-scope="{ option }">{{ option.label }}</span>
                </el-transfer>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveRoleMemberDataClickFun()" style="width: 80px;">保存</el-button>
                <el-button @click="addRoleMemberDialogVisible = false" style="width: 80px;">返回</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import https, { fetchPost } from '../../../../https.js';
    export default {
        data() {
            return {
                pwm: {
                    count: 0,
                    limit: 10,
                    page: 1,
                    limits: [10, 20, 50, 100]
                },
                roleIdVal: '',
                roleNameVal: '所有者',
                roleNameDescVal: '系统默认角色，默认具有企业所有功能权限和全部数据可见范围',
                roleMemberCount: 0,
                roleTreeData: [],
                defaultExpandRoleNode: [],  //  默认展开的节点
                defaultProps: {
                    children: 'children',
                    label: 'label',
                    disabled: this.disabledFunAuth
                },
                roleManageTabs: 'roleMember',
                roleManageSearchName: '',
                show: false,
                roleMemberTableData: [],
                addRoleDialogVisible: false,
                addGroupDialogVisible: false,
                addRoleForm: {
                    roleName: '',
                    roleGroupId: '',
                    description: ''
                },
                addRoleFormRule: {
                    roleName: [
                        { required: true, message: '请输入角色名', trigger: 'blur' },
                        { max: 10, message: '角色名不得超过10个字符'},
                        { validator: this.checkRoleName }
                    ],
                    roleGroupId: [
                        { required: true, message: '请选择角色组', trigger: 'blur' }
                    ],
                    description: [
                        { required: false, max: 30, message: '描述不得超过30个字符'}
                    ]
                },
                roleGroupComboData: [],  //  角色组下拉数据
                addGroupForm: {
                    groupName: ''
                },
                addGroupFormRule: {
                    groupName: [
                        { required: true, message: '请输入分组名称', trigger: 'blur' },
                        { max: 10, message: '分组名称不得超过10个字符' }
                    ]
                },
                defaultExpandAll: true,    //  功能权限 tree 默认展开所有
                showFunAuthBtn: true,   //  是否显示功能权限保存按钮
				functionAuthTreeData: [],
                defaultCheckedMenu: [],
                menuId: '',
                menuName: '',
                showMenuBtn: false, //  是否显示菜单按钮
                checkBtnList: [],
                childBtnList: [],
                currMenuNodeData: [],   //  当前点击操作的菜单节点数据
                roleDataRangeForm: {
                    dataRangeId: '',
                    levelAuthList: '',
                    archivesTypeList: [],
                },
                dataRangeData: {},
                dataRangeDisabled:  false,
                addRoleMemberDialogVisible: false,
                roleMemberChecked: [], 
                roleMemberData: [],
                groupComboData: [],  //  所有集团信息
                currGroupId: '',
                currUserType:   '',  //  当前用户的类型
                currClickRoleData:  ''  //  当前所点击的角色数据
           }
        },
        created: function() {
            //  判断当前用户是否是超级管理员
            this.getCurrentUserList().then(currUser => {
                if(currUser.userType == '0') {   //  超管
                    this.getAllGroupData().then((val) => {
                        this.getRoleTreeList();
                    });
                } else {
                    this.getCurrentGroupData().then((val) => {
                        this.getRoleTreeList();
                    });
                }
                this.currUserType = currUser.userType;
            });
        },
        methods: {
            handleSizeChange(val) {
                this.pwm.limit = val;
                this.getMemberListByRoleId();
            },
            handleCurrentChange(val) {
                this.pwm.page = val;
                this.getMemberListByRoleId();
            },
            clickRowByChecked(row) {    //  点击即选中该行
                this.$refs.roleMemberTable.toggleRowSelection(row);
            },
            currGroupSelectChange(newVal) { //  当前集团 select change事件
                this.currGroupId = newVal;
                this.roleMemberTableData = [];
                this.getRoleTreeList();
            },
            async getAllGroupData() {   //  获取所有集团数据
                await fetchPost('/sys/admin/getAllCompanyGroup', '').then(res => {
                    if(res.data.success) {
                        this.groupComboData = res.data.obj;
                        if(this.groupComboData && this.groupComboData.length > 0) {
                            this.currGroupId = this.groupComboData[0].id;
                        }
                    } else {
                        this.$message.error('获取所有集团信息失败：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('获取所有集团信息失败：' + error);   
                });
            },
            async getCurrentGroupData() { //  当前集团信息 : 同步执行
                await fetchPost('/sys/admin/getCurrentCompanyGroup', '').then(res => {
                    if(res.data.success) {
                        this.groupComboData.push(res.data.obj);
                        this.currGroupId = res.data.obj.id;
                    } else {
                        this.$message.error('获取当前集团信息错误：' + res.data.message);
                        return;
                    }
                }, error => {
                    this.$message.error('获取当前集团信息错误：' + error);
                });
            },
            getRoleTreeList() {
                let params = { "groupId": this.currGroupId };
                fetchPost('/sys/admin/getRoleListData', params).then(res => {
                    if(res.data.success) {
                        this.roleTreeData = res.data.obj;
                        if(res.data.obj && res.data.obj.length > 0) {
                            let firstNode = res.data.obj[0];
                            this.defaultExpandRoleNode = [firstNode.id];  //  默认展开第一个角色组数据
                            if(firstNode.children && firstNode.children.length > 0) {
                                this.roleIdVal = firstNode.children[0].id;
                                this.roleNameVal = firstNode.children[0].label;
                                this.roleNameDescVal = firstNode.children[0].desc;

                                this.currClickRoleData = firstNode.children[0];    //  当前点击的角色
                            } else {
                                this.roleIdVal = '';
                                this.roleNameVal = firstNode.label;
                                this.roleNameDescVal = '';
                            }
                            this.getMemberListByRoleId();
                            this.getAllMenuListByRoleId(); // 功能权限
                            this.getRoleDataRangeList();
                        }
                    } else {
                        this.$message.error('加载角色数据错误：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('加载角色数据错误：' + error);
                });
            },
            getAllRoleGroupDataByCurrGroupId() {    //  获取当前集团下所有的角色组数据
                fetchPost('/sys/admin/getRoleGroupByCompanyGroup', this.currGroupId).then(res => {
                    if(res.data.success) {
                        this.assembleRoleGroupComboData(res.data.obj);
                    } else {
                        this.$message.error('获取角色组数据错误：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('获取角色组数据错误：' + error);
                });
            },
            async assembleRoleGroupComboData(roleGroupData) {
                let roleGroupComboData = [];
                if(roleGroupData && roleGroupData.length > 0) {
                    roleGroupData.forEach(roleGroup => {
                        roleGroupComboData.push({value: roleGroup.id, label: roleGroup.groupName});
                    });
                }
                this.roleGroupComboData = roleGroupComboData;
            },
            async getMemberListByRoleId() {   //  获取当前选中角色关联的成员数据
                 this.pwm.page = 1;
                this.pwm.limit = 10;
                this.pwm.search = { 'roleId': this.roleIdVal, 'groupId': this.currGroupId };
                await fetchPost('/sys/admin/getUserListByRole', this.pwm).then(res => {
                    this.roleMemberTableData = res.data.data;
                    this.pwm.count = res.data.count;
                    this.roleMemberCount = res.data.count;
                }, error => {
                    this.$message.error('查询角色成员信息失败：' + error);
                });
            },
            getAllRoleMemberByCurrGroupId() {   //  获取当前集团下所有角色成员数据
                fetchPost('/sys/admin/getCompanyGroupUserList', this.currGroupId).then(res => {
                    if(res.data.success) {
                        this.roleMemberData = res.data.obj;
                    } else {
                        this.$message.error('加载集团下所有成员信息失败：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('加载集团下所有成员信息失败：' + error);
                });
            },
            getCheckedRoleMemberByRoleId() {    //  获取当前选中角色下的已关联的成员数据
                fetchPost('/sys/admin/getExsitsUserByRole', this.roleIdVal).then(res => {
                    if(res.data.success) {
                        let checkMemberData = res.data.obj;
                        let memberIdList = [];
                        checkMemberData.forEach(member => {
                            memberIdList.push(member.key);
                        })
                        this.roleMemberChecked = memberIdList;
                    } else {
                        this.$message.error('加载当前角色已关联成员信息失败：' + res.data.message);    
                    }
                }, error => {
                    this.$message.error('加载当前角色已关联成员信息失败：' + error);
                });
            },
			getAllMenuListByRoleId() {
                if(!this.roleIdVal) {
                    return;
                }
                fetchPost('/sys/main/getRoleMenuFunctionList', this.roleIdVal).then(res => {
                    if(res.data.success) {
                        this.functionAuthTreeData = res.data.obj;
                        this.defaultCheckedMenu = [];
                        fetchPost('/sys/admin/getRoleMenuIdList', this.roleIdVal).then(res => {
                            if(res.data.success) {
                                this.defaultCheckedMenu = res.data.obj;
                            }
                        }, error => {
                            this.$message.error('加载数据错误：' + error);
                        });
                    } else {
                        this.$message.error('加载角色数据错误：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('加载角色数据错误：' + error);
                });
            },
            async getRoleDataRangeList() {    //  获取当前角色数据权限范围
                if (!this.roleIdVal) {
                    return;
                }
                this.roleDataRangeForm.dataRangeId = '';
                this.roleDataRangeForm.levelAuthList = '';
                this.roleDataRangeForm.archivesTypeList = [];
                await fetchPost('/sys/admin/getRoleDataRangeConfigByRole', this.roleIdVal).then(res => {
                    if(res.data.success) {
                        this.processRoleDataRangeList(res.data.obj);
                    } else {
                        this.$message.error('加载数据范围配置信息失败：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('加载数据范围配置信息失败：' + error);
                });
            },
            async processRoleDataRangeList(dataRangeList) {
                // let levelAuthArr = [];
                let archivesTypeArr = [];
                if(dataRangeList && dataRangeList.length > 0) {
                    let dataRange = dataRangeList[0];
                    // if(dataRange.secretOne && dataRange.secretOne == '1') {
                    //     levelAuthArr.push('1');
                    // }
                    // if(dataRange.secretTwo && dataRange.secretTwo == '1') {
                    //     levelAuthArr.push('2');
                    // }
                    // if(dataRange.secretThree && dataRange.secretThree == '1') {
                    //     levelAuthArr.push('3');
                    // }
                    // if(dataRange.secretFour && dataRange.secretFour == '1') {
                    //     levelAuthArr.push('4');
                    // }
                    // if(dataRange.secretFive && dataRange.secretFive == '1') {
                    //     levelAuthArr.push('5');
                    // }
                    if(dataRange.archivesVoucher && dataRange.archivesVoucher == '1') {
                        archivesTypeArr.push('1');
                    }
                    if(dataRange.archivesBooks && dataRange.archivesBooks == '1') {
                        archivesTypeArr.push('2');
                    }
                    if(dataRange.archivesReport && dataRange.archivesReport == '1') {
                        archivesTypeArr.push('3');
                    }
                    if(dataRange.archivesOther && dataRange.archivesOther == '1') {
                        archivesTypeArr.push('4');
                    }
                    this.roleDataRangeForm.dataRangeId = dataRange.id;
                    this.roleDataRangeForm.levelAuthList = dataRange.secretLevel;
                    this.roleDataRangeForm.archivesTypeList = archivesTypeArr;
                }
            },
            roleTreeNodeClick(data) {
                if(data.type == '1') {  //  type: 0 ==> 角色组 type: 1 ==> 角色
                    this.roleIdVal = data.id;
                    this.roleNameVal = data.label;
                    this.roleNameDescVal = data.desc;
                    this.currClickRoleData = data;

                    this.getMemberListByRoleId();
					this.getAllMenuListByRoleId(); // 功能权限
                    this.getRoleDataRangeList();

                    //  控制功能权限是否能编辑
                    this.controlFunAuth();
                }
            },
            roleTreeNodeMouseEnter(data) {  //  tree 节点：鼠标移上
                this.$set(data, 'del', true);
            },
            roleTreeNodeMouseLeave(data) {  //  tree 节点：鼠标移走
                this.$set(data, 'del', false);
            },
            funAuthNodeClick(data) {    //  功能权限
                this.childBtnList = [];
                this.menuId = data.id;
                this.menuName = data.label;
                if(data.childbtn && data.childbtn.length > 0) {
                    this.showMenuBtn = true;
                    let childbtns = JSON.parse(JSON.stringify(data.childbtn));
                    this.childBtnList = childbtns;
                    //  显示已勾选的按钮
                    let checkBtnList = [];
                    childbtns.forEach(btnObj => {
                        if(btnObj.checked) {
                            checkBtnList.push(btnObj.id);
                        }
                    });
                    this.checkBtnList = checkBtnList;

                    //  保存当前点击的节点数据
                    this.currMenuNodeData = data;
                }
            },
            menuBtnChangeFun(checked) {    //   按钮 change方法
                let menuId = this.menuId;
                let currMenuData = this.currMenuNodeData;
                if(currMenuData && currMenuData.childbtn && currMenuData.childbtn.length > 0) {
                    currMenuData.childbtn.forEach(btnObj => {
                        if(this.checkBtnList.includes(btnObj.id)) {
                            btnObj.checked = true;
                        } else {
                            btnObj.checked = false;
                        }
                    });
                }
                this.$refs.functionAuthTree.updateKeyChildren(currMenuData.id, currMenuData);
            },
            advanceQueryRoleMemberData() {  //  高级查询
                this.pwm.likeSearch = this.roleManageSearchName;
                this.getMemberListByRoleId();
            },
            addGroupClickFun() {    //  新建分组
                Object.keys(this.addGroupForm).map(key => (this.addGroupForm[key] = ''));
                this.$nextTick(() => {
                    if(this.$refs.addGroupForm) {
                        this.$refs.addGroupForm.clearValidate();   //  重置表单校验
                    }
                });
                this.addGroupDialogVisible = true;
            },
            saveGroupDataClickFun(formName) {   //  保存分组
                this.$refs[formName].validate((valid) => {
                    if(!valid) {
                        return false;
                    }
                    let params = {
                        groupName: this.addGroupForm.groupName,
                        companyGroupId: this.currGroupId
                    };
                    fetchPost('/sys/admin/saveRoleGroup', params).then(result => {
                        let res = result.data;
                        if(res.success) {
                            this.$message.success('保存分组数据成功！');
                            this.addGroupDialogVisible = false;
                            //  reload role tree data
                            this.getRoleTreeList();
                        } else {
                            this.$message.error('保存分组数据失败：' + res.message);
                        }
                    }).catch(error => {
                        this.$message.error('保存分组数据失败：' + error);
                    });
                });
            },
            addRoleClickFun() { //  新建角色
                Object.keys(this.addRoleForm).map(key => (this.addRoleForm[key] = ''));
                this.$nextTick(() => {
                    if(this.$refs.addRoleForm) {
                        this.$refs.addRoleForm.clearValidate();   //  重置表单校验
                    }
                });
                this.addRoleDialogVisible = true;
                //  load role group select data
                this.getAllRoleGroupDataByCurrGroupId();
            },
            saveRoleDataClickFun(formName) {
                this.$refs[formName].validate((valid) => {
                    if(!valid) {
                        return false;
                    }
                    let roleData = this.addRoleForm;
                    roleData.companyGroupId = this.currGroupId;
                    fetchPost('/sys/admin/saveRole', roleData).then(res => {
                        if(res.data.success) {
                            this.$message.success('保存角色信息成功！');
                            //  close dialog
                            this.addRoleDialogVisible = false;
                            //  reload role tree
                            this.getRoleTreeList();
                        } else {
                            this.$message.error('保存角色信息失败：' + res.data.message);
                        }
                    }, error => {
                        this.$message.error('保存角色信息失败：' + error);
                    });
                });
            },
            deleteRoleTreeNode(node, data) {    //  删除角色
                if(data.type == '0') {  //  删除角色组
                    this.deleteRoleGroup(data);
                } else if(data.type == '1') {   //  删除角色
                    this.deleteRole(node);
                }
            },
            deleteRoleGroup(nodeData) { //  删除角色组
                if(nodeData.groupType && nodeData.groupType == '0') {   //  默认初始化的角色组不能删除
                    this.$message.error('默认初始化的分组不支持删除！');
                    return;
                }
                if(nodeData.children && nodeData.children.length > 0) {
                    this.$message.error('当前分组下有角色，不支持删除！');
                    return;
                }
                this.$confirm('是否确认删除选中的分组‘' + nodeData.label + '’？', '提示', { type: 'warning' }).then(res =>{
                    fetchPost('/sys/admin/deleteRoleGroup', nodeData.id).then(res => {
                        if(res.data.success) {
                            this.$message.success('删除分组成功！');
                            this.getRoleTreeList();
                        } else {
                            this.$message.error('删除分组失败：' + res.data.message);
                        }
                    }, error => {
                        this.$message.error('删除分组失败：' + error);
                    });
                });
            },
            deleteRole(node) {  //  删除角色
                let groupType = node.parent.data.groupType;
                if(groupType && groupType == '0') { //  默认初始化的角色不支持删除
                    this.$message.error('默认初始化的角色不支持删除！');
                    return;
                }
                let nodeData = node.data;
                if(this.roleMemberTableData && this.roleMemberTableData.length > 0) {
                    this.$message.error('当前角色下有关联用户，不支持删除！');
                    return;
                }
                this.$confirm('是否确认删除选中的角色‘' + nodeData.label + '’？', '提示', { type: 'warning' }).then(res =>{
                    fetchPost('/sys/admin/deleteRole', nodeData.id).then(res => {
                        if(res.data.success) {
                            this.$message.success('删除角色成功！');
                            this.getRoleTreeList();
                        } else {
                            this.$message.error('删除角色失败：' + res.data.message);
                        }
                    }, error => {
                        this.$message.error('删除角色失败：' + error);
                    });
                });
            },
            addRoleMemberClickFun() {   //  添加成员
                if(!this.roleIdVal || this.roleIdVal == '') {
                    this.$message.warning('未选择对应角色添加关联成员信息！');
                    return;
                }
                this.addRoleMemberDialogVisible = true;
                this.getAllRoleMemberByCurrGroupId();   //  所有成员数据
                this.getCheckedRoleMemberByRoleId();    //  角色已选择成员
            },
            saveRoleMemberDataClickFun() {  //  保存角色添加关联成员数据
                let params = { 'roleId': this.roleIdVal, 'ids': this.roleMemberChecked.toString() };
                fetchPost('/sys/admin/saveUserRole', params).then(res => {
                    if(res.data.success) {
                        this.$message.success('保存角色成员信息成功！');
                        this.addRoleMemberDialogVisible = false;
                        this.getMemberListByRoleId();
                    } else {
                        this.$message.error('保存角色成员信息失败：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('保存角色成员信息失败：' + error);
                });
            },
            deleteRoleMemberClickFun() {    //  批量移除
                let idList = [];
                let checkRows = this.$refs.roleMemberTable.selection;
                if(!checkRows || checkRows.length == 0) {
                    this.$message.warning('请选择需要移除的角色成员数据！');
                    return;
                }
                checkRows.forEach(row => {
                    idList.push(row.id);
                });
                let params = { 'roleId': this.roleIdVal, 'ids': idList.join(',') };
                fetchPost('/sys/admin/deleteUserRoles', params).then(res => {
                    if(res.data.success) {
                        this.$message.success('移除角色成员信息成功！');
                        this.getMemberListByRoleId();
                    } else {
                        this.$message.error('移除角色成员信息失败：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('移除角色成员信息失败：' + error);
                });
            },
            saveRoleAuthBtn() {
                this.saveFunAuth();
                this.saveRoleDataRangeClickFun();
            },
			saveFunAuth() {
                let checkNodes = this.$refs.functionAuthTree.getCheckedNodes();
                let params = { 'roleId': this.roleIdVal, 'checkNodes': JSON.stringify(checkNodes) };
                fetchPost('/sys/admin/saveRoleMeunFunction', params).then(res => {
                    if(res.data.success) {
                        this.$message.success('保存功能权限成功！');
                        this.getMemberListByRoleId();
                    } else {
                        this.$message.error('保存功能权限失败：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('保存功能权限失败：' + error);
                });
            },
            saveRoleDataRangeClickFun() {   //  保存数据范围
                this.assembleRoleDataRange(this.roleDataRangeForm).then(val => {
                    fetchPost('/sys/admin/saveRoleDataRangeConfig', this.dataRangeData).then(res => {
                        if(res.data.success) {
                            this.$message.success('保存数据范围配置信息成功！');
                            this.getRoleDataRangeList();
                        } else {
                            this.$message.error('保存数据范围配置信息失败：' + res.data.message);
                        }
                    }, error => {
                        this.$message.error('保存数据范围配置信息失败：' + error);
                    });
                });
            },
            async assembleRoleDataRange(roleDataRangeForm) {
                this.dataRangeData.roleId = this.roleIdVal;
                this.dataRangeData.id = roleDataRangeForm.dataRangeId;
                this.dataRangeData.secretLevel = roleDataRangeForm.levelAuthList;
                // let levelAuthList = roleDataRangeForm.levelAuthList;
                // levelAuthList.forEach(levelAuth => {
                //     if(levelAuth == '1') {  //  1级
                //         this.dataRangeData.secretOne = '1';
                //     } else if(levelAuth == '2') {   //  2级
                //         this.dataRangeData.secretTwo = '1';
                //     } else if(levelAuth == '3') {   //  3级
                //         this.dataRangeData.secretThree = '1';
                //     } else if(levelAuth == '4') {   //  4级
                //        this.dataRangeData.secretFour = '1';
                //     } else if(levelAuth == '5') {   //  5级
                //         this.dataRangeData.secretFive = '1';
                //     }
                // });
                let archivesTypeList = roleDataRangeForm.archivesTypeList;
                archivesTypeList.forEach(archivesType => {
                    if(archivesType == '1') {
                        this.dataRangeData.archivesVoucher = '1';
                    } else if(archivesType == '2') {
                        this.dataRangeData.archivesBooks = '1';
                    } else if(archivesType == '3') {
                        this.dataRangeData.archivesReport = '1';
                    } else if(archivesType == '4') {
                        this.dataRangeData.archivesOther = '1';
                    }
				});
			},
            checkRoleName(rule, value, cb) {
                if(this.addRoleForm.roleName == '集团管理员') {
                    cb(new Error('角色名不能为‘集团管理员’'));
                } else {
                    return cb()
                }
            },
            controlFunAuth() {  //  控制功能权限是否能编辑
                if(this.currUserType != this.userTypeCon.USER_TYPE_SUPER) {
                    if(this.currUserType == this.userTypeCon.USER_TYPE_GROUP  && this.currClickRoleData && this.currClickRoleData.roleType == this.roleTypeCon.ROLE_TYPE_GROUP) { 
                        //  当前用户为集团管理员且所选角色为集团管理员则不允许修改功能权限、数据范围不可编辑
                        this.showFunAuthBtn = false;
                        this.dataRangeDisabled = true;  //  数据范围不可编辑
                    } else if(this.currUserType == this.userTypeCon.USER_TYPE_ORDINARY && this.currClickRoleData && this.currClickRoleData.roleType == this.roleTypeCon.ROLE_TYPE_GROUP) {
                        //  当前用户为集团用户且所选角色为集团管理员则不允许修改功能权限、数据范围不可编辑
                        this.showFunAuthBtn = false;
                        this.dataRangeDisabled = true;  //  数据范围不可编辑
                    } else {
                        this.showFunAuthBtn = true;
                        this.dataRangeDisabled = false;
                    }
                }
            },
            disabledFunAuth() {
                if(this.dataRangeDisabled) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        watch: {
            'roleManageTabs': function(val) {
                if(val == 'functionAuth') {
                    this.controlFunAuth();
                }
            }
        }
    }
</script>

<style scoped>
    .container {
        color: #606266;
        font-size: 14px;
    }
    .table {
        width: 100%;
        font-size: 14px;
    }
    .el-dialog {
        margin: 0 auto !important;
    }
    .el-dialog__header {
        padding: 0 !important;
    }
    .el-dialog__wrapper {
        display: flex ;
        align-items: center ;
    }
    .custom-add-member-dialog /deep/ .el-transfer__buttons {
        padding: 0px 15px !important;
    }
    .custom-tree-node {
        /* flex: 1; */
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 8px;
    }
</style>